// extracted by mini-css-extract-plugin
var _1 = "KeyboardShortcutsPanel-module__animateUploadProgressBarWidth--kbkvK";
var _2 = "KeyboardShortcutsPanel-module__animatedBackground--3qWsa";
var _3 = "KeyboardShortcutsPanel-module__mono--xPamf";
var _4 = "KeyboardShortcutsPanel-module__muted--WCegz";
var _5 = "KeyboardShortcutsPanel-module__rowContainer--V7Azx";
var _6 = "KeyboardShortcutsPanel-module__rowName--PcCw2";
var _7 = "KeyboardShortcutsPanel-module__sectionContainer--WQ0nT";
var _8 = "KeyboardShortcutsPanel-module__sectionTitle--s5ywO";
var _9 = "KeyboardShortcutsPanel-module__separator--zE9uV";
var _a = "KeyboardShortcutsPanel-module__shortcutsList--tzHni";
var _b = "KeyboardShortcutsPanel-module__small--ky1tw";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "mono", _4 as "muted", _5 as "rowContainer", _6 as "rowName", _7 as "sectionContainer", _8 as "sectionTitle", _9 as "separator", _a as "shortcutsList", _b as "small" }
